<template>
  <el-dialog
    :title="typeof dgItem.id !== 'undefined' ? 'Edit DG' : 'Create DG'"
    visible
    top="5vh"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="dgItemForm"
      v-loading="isSaving"
      :rules="rules"
      :model="dgItem"
      size="small"
    >
      <el-row>
        <el-col :md="24">
          <el-row :gutter="10">
            <el-col :md="12">
              <el-form-item
                label="Proper Name"
                prop="itemdg_propname"
              >
                <el-input
                  v-model="dgItem.itemdg_propname"
                  placeholder=""
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item
                label="Common Name"
                prop="itemdg_comname"
              >
                <el-input
                  v-model="dgItem.itemdg_comname"
                  placeholder=""
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :md="12">
              <el-form-item
                label="Product Class"
                prop="itemdg_prodclass"
              >
                <el-input
                  v-model="dgItem.itemdg_prodclass"
                  placeholder=""
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item
                label="Packaging Type"
                prop="itemdg_packtype"
              >
                <el-input
                  v-model="dgItem.itemdg_packtype"
                  placeholder="Composite packaging"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :md="8">
              <el-form-item
                label="UN Number"
                prop="itemdg_unno"
              >
                <el-autocomplete
                  v-model="dgItem.itemdg_unno"
                  :fetch-suggestions="unQuerySearch"
                  placeholder="Enter UN Number"
                  :trigger-on-focus="false"
                  class="w-100"
                  placement="top"
                  :debounce="500"
                  clearable
                  @select="handleUNSelect"
                >
                  <template v-slot="{ item }">
                    {{ formatUNEntry(item) }}
                  </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item
                label="Class"
                prop="itemdg_hazclass"
              >
                <el-input
                  v-model="dgItem.itemdg_hazclass"
                  placeholder="6.1"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item
                label="Subsidiary Risk"
                prop="itemdg_subrisk"
              >
                <el-input
                  v-model="dgItem.itemdg_subrisk"
                  placeholder="2.0"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :md="8">
              <el-form-item
                label="Hazchem Code"
                prop="itemdg_hazcode"
              >
                <el-input
                  v-model="dgItem.itemdg_hazcode"
                  placeholder=""
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item
                label="Packing Group"
                prop="itemdg_packgroup"
              >
                <el-select
                  v-model="dgItem.itemdg_packgroup"
                  filterable
                  class="w-100"
                >
                  <el-option
                    v-for="packagingGroup in packagingGroups"
                    :key="packagingGroup.key"
                    :label="packagingGroup.value"
                    :value="packagingGroup.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item
                label="Flash Point"
                prop="itemdg_flashpt"
              >
                <el-input
                  v-model="dgItem.itemdg_flashpt"
                  placeholder="60"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <hr>
          <el-row :gutter="10">
            <el-col :md="12">
              <el-form-item
                label="Short Code (API Use)"
                prop="itemdg_apicode"
              >
                <el-input
                  v-model="dgItem.itemdg_apicode"
                  placeholder="Code to be used in API Requests"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item
                label="Marine Pollutant"
                prop="itemdg_marpol"
              >
                <el-select
                  v-model="dgItem.itemdg_marpol"
                  filterable
                  class="w-100"
                >
                  <el-option
                    key="0"
                    label="No"
                    :value="false"
                  />
                  <el-option
                    key="1"
                    label="Yes"
                    :value="true"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="24">
              <el-form-item
                label="Additional Information"
                prop="itemdg_addinfo"
              >
                <el-input
                  v-model="dgItem.itemdg_addinfo"
                  placeholder="Please enter any additional information"
                  type="textarea"
                  :rows="4"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <hr>
          <el-row>
            <h5>International Use</h5>
            <el-col :md="12">
              <el-form-item
                label="Short Code (API Use)"
                prop="itemdg_apicode"
              >
                <el-input
                  v-model="dgItem.itemdg_apicode"
                  placeholder="Code to be used in API Requests"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="typeof dgItem.id !== 'undefined' ? updatedgItem() : createdgItem()"
      >
        {{ typeof dgItem.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import Filter, { CONTAINS } from '@/plugins/sdk/Filter'

export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    dgItem: {
      type: Object,
      required: true
    },
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      exampleDGItem: {
        unNumber: 'UN1993'
      },
      packagingGroups: [
        {
          key: 1,
          value: 'Group 1 (I)'
        },
        {
          key: 2,
          value: 'Group 2 (II)'
        },
        {
          key: 3,
          value: 'Group 3 (III)'
        }
      ],
      isSaving: false,
      isFullscreen: false,
      rules: {
        name: [
          { required: true, message: 'Name of the address is required', trigger: 'blur' }
        ],
        line_one: [
          { required: true, message: 'Line one of the address is required', trigger: 'blur' }
        ],
        suburb: [
          { required: true, message: 'Please enter and select a suburb from the list', trigger: 'change' }
        ],
        state: [
          { required: true, message: 'State of the address is required', trigger: 'change' }
        ],
        postcode: [
          { required: true, message: 'Postcode of the address is required', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    createdgItem () {
      this.$refs.dgItemForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.$sdk.account_itemsdg.create(this.dgItem, builder => {
            builder.context = { resource: 'account', id: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    updatedgItem () {
      this.$refs.dgItemForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.dgItem.update(builder => {
            builder.context = { resource: 'account', id: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    unQuerySearch (queryString, cb) {
      this
        .$sdk
        .dangerous_goods
        .list(builder => {
          const filters = [
            new Filter('un_number', CONTAINS, queryString)
          ]
          builder.filters = filters
          builder.page = 1
          builder.limit = 50
        })
        .then(cb)
    },
    handleUNSelect (item) {
      this.dgItem.itemdg_unno = item.un_number
      this.dgItem.itemdg_packgroup = item.packing_group
      this.dgItem.itemdg_hazclass = item.class
    },
    formatUNEntry (unEntry) {
      if (unEntry) {
        return `${unEntry.un_number}, ${unEntry.packing_group}, ${unEntry.class}`
      } else return ''
    }
  }
}
</script>

<style>

</style>
